import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'srdActivityInfo',
  standalone: true
})
export class SrdActivityInfoPipe implements PipeTransform {

  transform(productsRow: any, productId: any): any {
    if (!productsRow?.activity) return null;

    const result = productsRow.activity
      .sort(
        (a: any, b: any) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      )
      .find((item: any) => item.activity_type_id == 91 && item.product_id == productId);

    if (result?.frontend_user?.id) {
      return {
        user_name: `${result.frontend_user.first_name} ${result.frontend_user.last_name}`,
        change_at: result.created_at ? moment(result.created_at).format('DD/MM/YYYY') : 'N/A',
        user_profile: result.frontend_user.profile_picture,
        is_changed_from_frontend: true
      };
    }

    if (result?.backend_user?.id) {
      return {
        user_name: `${result.backend_user.first_name} ${result.backend_user.last_name}`,
        change_at: result.created_at ? moment(result.created_at).format('DD/MM/YYYY') : 'N/A',
        user_profile: result.backend_user.profile_picture
      };
    }

    return null;
  }
}
